import { gsap } from 'gsap/all'

export const updateBubble = (qty: number): void => {
  const qtyBubbles = document.querySelectorAll<HTMLElement>('.checkout-button__cart-count')

  if (qtyBubbles) {
    qtyBubbles.forEach((qtyBubble) => {
      if (!qtyBubble.classList.contains('checkout-button__cart-count--visible')) {
        qtyBubble.classList.add('checkout-button__cart-count--visible')
      }

      const background = qtyBubble.querySelector('.checkout-button__cart-count-background')
      const orb = qtyBubble.querySelector('.checkout-button__cart-count-orb')
      const text = qtyBubble.firstElementChild

      text.innerHTML = qty.toString()
      gsap.fromTo(
        orb,
        { opacity: 1, scale: 0.75 },
        { duration: 1.5, ease: 'power3.out', opacity: 0, scale: 2 }
      )
      gsap.to(background, { duration: 0.12, ease: 'none', scale: 1.2 })
      gsap.to(background, { delay: 0.12, duration: 1.5, ease: 'elastic.out', scale: 1 })

      if (qty < 1) {
        qtyBubble.classList.remove('checkout-button__cart-count--visible')
      }
    })
  }
}
